import { Provider } from '@angular/core';
import { provideRoutes } from 'routing-util';
import { defaultOrdersFeatureRoutesConfig, OrdersFeatureRoutesConfig } from './OrdersFeatureRoutesConfig';

export function provideOrdersFeatureRoutes(config?: Partial<OrdersFeatureRoutesConfig>): Provider {
  const useConfig = { ...defaultOrdersFeatureRoutesConfig, ...config };
  return [
    provideRoutes([
      {
        path: useConfig.path,
        loadChildren: () => import('./routes/routes').then((m) => m.routes),
      },
    ]),
  ];
}
